import React from "react";
import PropTypes from "prop-types";
import { Grid } from "@mui/material";
import Card from "../../../components/Cards/Card";
import NativeObject from "../../../components/NativeObject/NativeObject";
import KpiCard from "../../../components/KpiCard/KpiCard";

const OBJECT_IDS = {
  COBERTURA_BASE: "gTPyYn",
  COBERTURA_BASE_META: "tEPszU",
  COBERTURA_BASE_REALIZADO: "KdhEZR",
  COBERTURA_BASE_ATINGIMENTO: "nLyJR",
  COBERTURA_BASE_TABLE: "ppPgQfw",
};

const PerformanceCard = ({ app, segment }) => {
  return (
    <Grid container className="container-cards-kpi">
      <Card
        app={app}
        className={"card-kpi-item"}
        key="COBERTURA_BASE"
        header={{
          hardTitle:
            segment === "farma" ? "Positivação Nivea" : "Nivea Trim. Móvel",
        }}
      >
        <KpiCard
          styles={{boxShadow: "none"}}
          app={app}
          valueId={segment === "farma" ? "qqkrTS" : OBJECT_IDS.COBERTURA_BASE_META}
          goalValueId={segment === "farma" ? "jamfgK" : OBJECT_IDS.COBERTURA_BASE_REALIZADO}
          percentageId={segment === "farma" ? "HrHPZtz" : OBJECT_IDS.COBERTURA_BASE_ATINGIMENTO}
          hasProgressBar={true}
          fullView
        />
        {segment !== "farma" && (
          <>
            <Grid container spacing={2}>
              <p className="text-kpi-table" style={{ marginTop: "2rem", marginBottom: "10px", marginLeft: "15px" }}>Ranking</p>
            </Grid>
            <NativeObject
              app={app}
              key={OBJECT_IDS.COBERTURA_BASE_TABLE}
              style={{ width: "100%", height: "40vh" }}
              reference={{ id: OBJECT_IDS.COBERTURA_BASE_TABLE }}
              className={"table-item-ranking"}
            />
          </>
        )}
      </Card>
    </Grid>
  );
};

PerformanceCard.propTypes = {
  app: PropTypes.object.isRequired,
  segment: PropTypes.string,
};

export default PerformanceCard;
